import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Share links sent from the preview open the published site instead
const PUBLISHED = process.env.REACT_APP_PUBLISHED_URL;
if (PUBLISHED && window.location.hostname.endsWith(".preview.emergentagent.com") && window.location.pathname.startsWith("/share/")) {
  window.location.replace(PUBLISHED.replace(/\/$/, "") + window.location.pathname);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
